import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getVariablesToBeAsked } from '../../AdditionalContractInfo/ContractFields/helpers'
import { formatInitialVariable, MEDIA_PRODUCTS, VARIABLES } from '../../fields'
import { useHandleAutoSave } from '../../useHandleAutoSave'
import { bookingVariablesSelector } from '../../../../../../modules/selectors/mediaOrdersBookings'

export const useAddProduct = ({ allowAutoSave, formik, handleProductEdit, productPath }) => {
  const bookingVariables = useSelector(bookingVariablesSelector)

  const { setFieldValue, setFieldTouched, validateForm, submitForm, values } = formik

  const onSuccessSave = useCallback(() => {
    handleProductEdit && handleProductEdit(null)

    // Determine which variables should be visible by comparing bookingVariables and selected media products
    const variablesToBeAsked = getVariablesToBeAsked(bookingVariables, values[MEDIA_PRODUCTS])
    // If there are more variables to be asked than those already in the form...
    if (variablesToBeAsked.length > values[VARIABLES].length) {
      // Filter out variables already present in the form's VARIABLES array and format the new variables
      const variablesToAdd = variablesToBeAsked
        .filter(variable => {
          // Exclude variables that are already in the form state by comparing their IDs
          return !values[VARIABLES].find(value => value.data.id === variable.id)
        })
        // Prepare each new variable for insertion into the form
        .map(variable => formatInitialVariable(variable))

      // Update the form state by appending the new variables to the existing list
      setFieldValue(VARIABLES, [...values[VARIABLES], ...variablesToAdd])
    }
  }, [handleProductEdit, setFieldValue, bookingVariables, values])

  const handleSaveProduct = useHandleAutoSave({
    onSuccessSave,
    // productPath is optional, in case when it's not added, the full form is validated
    productPath,
    setFieldTouched,
    validateForm,
    submitForm,
    allowAutoSave
  })

  return useMemo(
    () => ({
      handleSaveProduct
    }),
    [handleSaveProduct]
  )
}
